export enum PaymentTypeUnavailabilityReason {
    MIN_AMOUNT = "min_amount",
    MAX_AMOUNT = "max_amount",
    NOT_FOUND = "not_found",
}